import { type Enum } from '@webapp/infrastructure/types/Enum'

export const CardStatuses = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  CANCELED: 'canceled',
} as const

export type CardStatusEnum = Enum<typeof CardStatuses>
